const ZERO_INSETS = { top: 0, right: 0, bottom: 0, left: 0 };

/**
 * The browser has no notch or status bar to avoid, and the web build doesn't
 * ship react-native-safe-area-context - so the overlay needs no inset here.
 */
export function useRelicVaultInsets() {
  return ZERO_INSETS;
}
